import { useQuery } from '@tanstack/react-query'
import { adminService } from '../services/adminService'
import { StatsGrid } from '../components/StatsGrid'
import { RecentActivity } from '../components/RecentActivity'
import { useTranslation } from '../i18n/hooks/useTranslation'

export function AdminDashboard() {
  const { t } = useTranslation()
  
  const { data: stats, isLoading } = useQuery({
    queryKey: ['adminStats'],
    queryFn: () => adminService.getAdminStats(),
  })

  const { data: recentChallenges = [] } = useQuery({
    queryKey: ['recentChallenges'],
    queryFn: () => adminService.getRecentChallenges(3),
  })

  const { data: recentUsers = [] } = useQuery({
    queryKey: ['recentUsers'],
    queryFn: () => adminService.getRecentUsers(3),
  })

  if (isLoading) {
    return (
      <div className="p-8">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">{t('common.loading')}</div>
        </div>
      </div>
    )
  }

  return (
    <div className="p-8">
      {/* Enhanced Header */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 leading-tight">
              {t('dashboard.title')}
            </h1>
            <p className="text-gray-600 mt-2 text-sm lg:text-base leading-relaxed">
              {t('dashboard.subtitle')}
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 px-3 py-2 bg-blue-50 text-blue-700 rounded-lg">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm font-medium">Admin Panel</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-8">
        <StatsGrid stats={stats} clickable={true} />
      </div>

      <RecentActivity recentChallenges={recentChallenges} recentUsers={recentUsers} showUsers={true} />
    </div>
  )
}